<template>
  <v-card
    id="card"
    :class="statusClass(item)"
    class="card-text px-1 rounded-0"
    color=""
    style=""
  >
    <v-row>
      <v-col class="my-auto py-0">
        <v-row>
          <v-col cols="11">
            <v-row>
              <v-col cols="6" class="">
                {{ item.DayName }}
              </v-col>
              <v-col cols="6" class="">{{ item.DDATE }}</v-col>
            </v-row>
            <v-row class="py-0 my-0">
              <v-col>
                <div class="text-caption text-caption-color">
                  <span class="font-sahel">
                    ( {{ $t("Presence") }} :{{ item.WORKTOTAL }} )</span
                  >
                  <span class="font-sahel">
                    ( {{ $t("totalKasrKar") }} :{{ item.totalKasrKar }} )</span
                  >
                  <span class="font-sahel">
                    ( {{ $t("EXTRAWORKTOTAL") }} :{{ item.EXTRAWORKTOTAL }} )</span
                  >
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="1"
            style="justify-content: left; align-content: center; display: flex"
          >
            <div class="my-auto state">
              <v-icon color="red" v-if="item.totalKasrKar != '۰۰:۰۰'"
                >mdi-sort-clock-ascending-outline</v-icon
              >
              <v-icon color="teal" v-if="item.EXTRAWORKTOTAL != '۰۰:۰۰'"
                >mdi-sort-clock-descending-outline</v-icon
              >
              <v-icon color="blue" v-if="item.Morakhasi != '۰۰:۰۰'"
                >mdi-calendar-weekend</v-icon
              >
              <v-icon color="purple" v-if="item.MISSION != '۰۰:۰۰'"
                >mdi-bag-checked</v-icon
              >
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="my-auto py-0" cols="auto">
        <v-btn icon @click="show = !show" class="card-text">
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-expand-transition class="">
      <div v-show="show" class="mt-1">
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="6" class="my-auto py-0"
                >{{ $t("totalKasrKar") }} : <span class="text-value">{{ item.totalKasrKar }}</span>
              </v-col>
              <v-col cols="6" class="my-auto py-0"
                >{{ $t("EXTRAWORKTOTAL") }} : <span class="text-value">{{ item.EXTRAWORKTOTAL }}</span>
              </v-col>
              <v-col cols="6" class="my-auto py-0"
                >{{ $t("Morakhasi") }} : <span class="text-value">{{ item.Morakhasi }}</span>
              </v-col>
              <v-col cols="6" class="my-auto py-0"
                >{{ $t("MISSION") }} : <span class="text-value">{{ item.MISSION }}</span></v-col
              >
            </v-row>
          </v-col>
          <v-col cols="auto py-0">
            <div style="width: 36px; height: 36px"></div>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {
    statusClass(item) {
      var classList = [];
      if (Number(item.HOLIDAY) > 0) {
        classList.push("holiday");
      } else if (Number(item.DAILYABSENCE) > 0) {
        classList.push("absent");
      } else {
        classList.push("normal");
      }
      return classList;
      //.filter((c) => !!c)
      //.join("");
    },
  },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>